const backend_port = process.env.REACT_APP_BACKEND_PORT ? process.env.REACT_APP_BACKEND_PORT : 3333
const apiUrl = window.location.hostname === 'localhost' ? `https://localhost:${backend_port}` : `https://${window.location.hostname}:${backend_port}`;
//const csrfToken = localStorage.getItem('keepMeAlive');



export const fetchWithDefaults = async (url, options = {}) => {
//   const csrfToken = await localStorage.getItem('keepMeAlive');
  let defaultHeaders = {
    'Content-Type': 'application/json',
    // 'X-CSRF-Token': csrfToken,
  };
  const headers = { ...defaultHeaders, ...options.headers };
  const mergedOptions = { ...options, headers };
  if (mergedOptions.body instanceof FormData){
    delete mergedOptions.headers['Content-Type']
  }

  // Call the function to continuously update X-CSRF-Token header
//   updateCSRFToken(defaultHeaders, csrfToken);
  try {
    const response =await fetch(`${apiUrl}${url}`, mergedOptions);
    // const responseHeaders = response.headers;
    // const csrf = responseHeaders.get('X-CSRF-Token');
    // if(csrf){
    //     localStorage.setItem('KeepMeAlive',csrf)
    // }

    if (response.status === 500) {
      window.dispatchEvent(new CustomEvent("serverError"));
      throw new Error("Server returned 500");
    }
    return response;
  } catch (error) {
    throw new Error(error)
  }
};



function updateCSRFToken(headers, csrfToken) {
  headers['X-CSRF-Token'] = csrfToken;

  if (headers['X-CSRF-Token'] !== null) {

  }
  else {
      setTimeout(() => updateCSRFToken(headers), 500);
  }
}
